'use strict';

/*
 * Entry Collection object constructor.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
Entry.Collection = /*#__PURE__*/function () {
  function Collection(data) {
    (0, _classCallCheck2["default"])(this, Collection);
    (0, _defineProperty2["default"])(this, "remove", function (datum) {
      var index = this.indexOf(datum);
      if (index > -1) {
        delete this._hashMap[datum.id];
        this.splice(index, 1);
      }
    });
    this.length = 0;

    /*
     * object for hashing data with id
     * @private
     */
    this._hashMap = {};

    /*
     * observers
     */
    this._observers = [];
    this.set(data);
  }

  /* setters */
  return (0, _createClass2["default"])(Collection, [{
    key: "set",
    value: function set(data) {
      while (this.length) {
        Array.prototype.pop.call(this);
      }
      var hashMap = this._hashMap;
      for (var key in hashMap) {
        delete hashMap[key];
      }
      if (data !== undefined) {
        for (var i = 0, len = data.length; i < len; i++) {
          var datum = data[i];
          hashMap[datum.id] = datum;
          Array.prototype.push.call(this, datum);
        }
      }
    }
  }, {
    key: "push",
    value: function push(elem) {
      this._hashMap[elem.id] = elem;
      Array.prototype.push.call(this, elem);
    }
  }, {
    key: "unshift",
    value: function unshift() {
      var args = Array.prototype.slice.call(arguments, 0);
      var hashMap = this._hashMap;
      for (var i = args.length - 1; i >= 0; i--) {
        var datum = args[i];
        Array.prototype.unshift.call(this, datum);
        hashMap[datum.id] = datum;
      }
    }
  }, {
    key: "insert",
    value: function insert(datum, index) {
      Array.prototype.splice.call(this, index, 0, datum);
      this._hashMap[datum.id] = datum;
    }
  }, {
    key: "has",
    value: function has(id) {
      return !!this._hashMap[id];
    }
  }, {
    key: "get",
    value: function get(id) {
      return this._hashMap[id];
    }
  }, {
    key: "at",
    value: function at(index) {
      return this[index];
    }
  }, {
    key: "getAll",
    value: function getAll() {
      var len = this.length;
      var ret = [];
      for (var i = 0; i < len; i++) {
        ret.push(this[i]);
      }
      return ret;
    }
  }, {
    key: "indexOf",
    value: function indexOf(obj) {
      return Array.prototype.indexOf.call(this, obj);
    }
  }, {
    key: "find",
    value: function find(cond) {
      var ret = [];
      var flag;
      for (var i = 0, len = this.length; i < len; i++) {
        flag = true;
        var datum = this[i];
        for (var key in cond) {
          if (cond[key] != datum[key]) {
            flag = false;
            break;
          }
        }
        if (flag) {
          ret.push(datum);
        }
      }
      return ret;
    }
  }, {
    key: "pop",
    value: function pop() {
      var datum = Array.prototype.pop.call(this);
      delete this._hashMap[datum.id];
      return datum;
    }
  }, {
    key: "shift",
    value: function shift() {
      var datum = Array.prototype.shift.call(this);
      delete this._hashMap[datum.id];
      return datum;
    }
  }, {
    key: "slice",
    value: function slice(index, amount) {
      var data = Array.prototype.slice.call(this, index, amount);
      var hashMap = this._hashMap;
      for (var i in data) {
        delete hashMap[data[i].id];
      }
      return data;
    }
  }, {
    key: "splice",
    value: function splice(index, amount) {
      var args = Array.prototype.slice.call(arguments, 2);
      var hashMap = this._hashMap;
      amount = amount === undefined ? this.length - index : amount;
      var splicedData = Array.prototype.splice.call(this, index, amount);
      for (var i = 0, len = splicedData.length; i < len; i++) {
        delete hashMap[splicedData[i].id];
      }
      for (var _i = 0, _len = args.length; _i < _len; _i++) {
        var datum = args[_i];
        Array.prototype.splice.call(this, index++, 0, datum);
        this._hashMap[datum.id] = datum;
      }
      return splicedData;
    }
  }, {
    key: "clear",
    value: function clear() {
      while (this.length) {
        Array.prototype.pop.call(this);
      }
      this._hashMap = {};
    }
  }, {
    key: "map",
    value: function map(fn, param) {
      var array = [];
      for (var i = 0, len = this.length; i < len; i++) {
        array.push(fn(this[i], param));
      }
      return array;
    }
  }, {
    key: "moveFromTo",
    value: function moveFromTo(from, to) {
      var max = this.length - 1;
      if (from < 0 || to < 0 || from > max || to > max) {
        return;
      }
      Array.prototype.splice.call(this, to, 0, Array.prototype.splice.call(this, from, 1)[0]);
    }
  }, {
    key: "sort",
    value: function sort() {}

    /* import & export */
  }, {
    key: "fromJSON",
    value: function fromJSON() {}
  }, {
    key: "toJSON",
    value: function toJSON() {
      var json = [];
      for (var i = 0, len = this.length; i < len; i++) {
        json.push(this[i].toJSON());
      }
      return json;
    }

    /* observe methods */
  }, {
    key: "observe",
    value: function observe() {}
  }, {
    key: "unobserve",
    value: function unobserve() {}
  }, {
    key: "notify",
    value: function notify() {}

    /* end function */
  }, {
    key: "destroy",
    value: function destroy() {}
  }]);
}();